export function resolver(map) {
  var context = {};

  Object.keys(map).forEach(key => {
    Object.defineProperty(context, key, {
      get: () => map[key](context)
    })
  })

  context.extend = (map2) => resolver(Object.assign({}, map, map2))
  context.context = context;
  return context;
}

export function instance(instance) {
  return () => instance;
}

export function singleton(factory) {
  if (typeof factory !== 'function') {
    throw new Error("Invalid factory: " + typeof factory);
  }
  var instance;
  return (context) => {
    if (!instance) {
      instance = factory(context)
    }
    return instance;
  }
}

export default {
  resolver,
  instance,
  singleton
}


// WEBPACK FOOTER //
// ./src/api/di.js